import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { Area } from '@commons/models/domain/Area';
import { AreaPanelViewMode } from '@src/app/enum/area.enum';
import { AreasListComponent } from './areas-list/areas-list.component';
import { AreaTypeEnum } from '@commons/enums/area-type.enum';

@Component({
  selector: 'app-areas',
  templateUrl: './areas.component.html',
  styleUrls: ['./areas.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreasComponent implements OnInit {

  @ViewChild('areaList') private areaListComp: AreasListComponent;

  @Output() public close$: EventEmitter<void> = new EventEmitter();

  @Input('isVisible') public set visible(value: boolean) {
    this._isVisible = value;
  };

  public readonly AreaPanelViewMode = AreaPanelViewMode;

  public activeViewMode: AreaPanelViewMode;
  public editArea: Area | undefined;
  public _isVisible: boolean;
  public selectedAreaTypeInForm: AreaTypeEnum;

  constructor() { }

  ngOnInit(): void {
    this.activeViewMode = AreaPanelViewMode.List;
  }

  public onClickBackInForm(area: Area | void): void {
    this.editArea = undefined;
    this.activeViewMode = AreaPanelViewMode.List;

    if (area) {
      setTimeout(() => {
        this.areaListComp.showArea({ area, groupId: null as any, isUntaggedArea: true });
      }, 0);
    }
  }

  public onClickAddArea(area?: Area | void): void {
    area && (this.editArea = { ...area });
    this.activeViewMode = AreaPanelViewMode.Form;
  }

  public onSelectAreaType(type: AreaTypeEnum): void {
    this.selectedAreaTypeInForm = type;
  }

}
